import { render, staticRenderFns } from "./TestBankManager.vue?vue&type=template&id=44a8ffb0&scoped=true"
import script from "./TestBankManager.vue?vue&type=script&lang=js"
export * from "./TestBankManager.vue?vue&type=script&lang=js"
import style0 from "./TestBankManager.vue?vue&type=style&index=0&id=44a8ffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8ffb0",
  null
  
)

export default component.exports